var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { id: "dictamen-general", fluid: "" } },
    [
      !this.revision.respuesta.evaluacionGuardadaFinal
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _vm._v(
              "\n    Deberá finalizar el apartado evaluación invidual para continuar con el proceso.\n  "
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.solicitud && _vm.revision.respuesta?.evaluacion?.id
        ? _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.guardarDictamen.apply(null, arguments)
                },
              },
            },
            [
              _c("div", { staticClass: "line-break" }),
              _vm._v(" "),
              _c("b-container", {
                staticClass: "border text-justify",
                attrs: { id: "dictamen" },
              }),
              _vm._v(" "),
              _c(
                "b-container",
                {
                  staticClass: "border text-justify",
                  attrs: { id: "dictamen-solicitud" },
                },
                [
                  !_vm.solicitud.isReconsideracion()
                    ? _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "a"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud, de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora, recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 1. “Parámetros del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " respecto al\n              componente 1. Producción de investigación científica y humanística, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalPerfilFronteraCientifica
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos. Respecto al componente 2. Fortalecimiento y Consolidación de\n              la Comunidad, ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " actividades. Respecto al\n              componente 3. Divulgación ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "d"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora, recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora, recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 1. “Parámetros del SNII”"
                                            ),
                                          ]),
                                          _vm._v(" y en el\n              "),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 2. “Parámetros de Tecnología del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " considerados de manera conjunta y sus respectivas\n              equivalencias conforme al artículo 7, dado que respecto al componente 1. Producción de investigación científica, humanística\n              y tecnológica, ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalPerfilMixtoCientificaTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " actividades. Respecto al componente 3. Divulgación ya que\n              presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría\n              o nivel en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "c"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 23, 24, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora, recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso a, 10, 11, 12, 17, 18, 19, 20, 21 y 22 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 12, 23, 27 y 28 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores la Comisión Dictaminadora recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 2. “Parámetros de Tecnología del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " respecto al componente 1. Producción Tecnológica, ya que\n              presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteProduccionTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Desarrollo Tecnológico;\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponentePropiedadIntelectual
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Propiedad Intelectual; y,\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteTransferenciaTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Transferencia de Tecnología. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades. Respecto al componente 3. Divulgación ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación” "
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de\n              la trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "a"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 13, 14, 17, 18, 19, 20, 21, y 23 del\n              Reglamento del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el\n              Funcionamiento del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios\n              Específicos de Evaluación del Sistema Nacional de Investigadoras e Investigadores, la Comisión Revisora recomienda al\n              Consejo General del Sistema Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud, de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 17, 18, 19, 20, 21, y 23 del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el Funcionamiento del\n              Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios Específicos de Evaluación del\n              Sistema Nacional de Investigadoras e Investigadores la Comisión Revisora, recomienda al Consejo General del Sistema Nacional\n              de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 1. “Parámetros del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " respecto al\n              componente 1. Producción de investigación científica y humanística, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalPerfilFronteraCientifica
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos. Respecto al componente 2. Fortalecimiento y Consolidación de\n              la Comunidad, ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " actividades. Respecto al\n              componente 3. Divulgación ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "d"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 13, 14, 17, 18, 19, 20, 21 y 23 del Reglamento\n              del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el Funcionamiento\n              del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios Específicos de Evaluación\n              del Sistema Nacional de Investigadoras e Investigadores la Comisión Revisora, recomienda al Consejo General del Sistema\n              Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 17, 18, 19, 20, 21 y 23 del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el Funcionamiento del\n              Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios Específicos de Evaluación del\n              Sistema Nacional de Investigadoras e Investigadores la Comisión Revisora recomienda al Consejo General del Sistema Nacional\n              de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 1. “Parámetros del SNII”"
                                            ),
                                          ]),
                                          _vm._v(" y en el\n              "),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 2. “Parámetros de Tecnología del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " considerados de manera conjunta y sus respectivas\n              equivalencias conforme al artículo 7, dado que respecto al componente 1. Producción de investigación científica, humanística\n              y tecnológica, ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalPerfilMixtoCientificaTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " actividades. Respecto al componente 3. Divulgación ya que\n              presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de la\n              trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría\n              o nivel en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.solicitud.SOLICITUD_RIZOMA.tipoPerfil.id === "c"
                            ? _c(
                                "b-col",
                                [
                                  _vm.esAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 13, 14, 17, 18, 19, 20, 21 y 23 del Reglamento\n              del Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el Funcionamiento\n              del Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios Específicos de Evaluación\n              del Sistema Nacional de Investigadoras e Investigadores la Comisión Revisora, recomienda al Consejo General del Sistema\n              Nacional de Investigadoras e Investigadores otorgar la categoría o nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              Por lo anterior, y tomando en cuenta la valoración cualitativa y cuantitativa respecto de la trayectoria de la persona\n              solicitante a partir del análisis de la información registrada en el Perfil Único y las consideraciones presentadas en su\n              solicitud de conformidad con lo establecido en el marco de la\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Convocatoria 2026 para el Reconocimiento en el Sistema Nacional de Investigadoras e Investigadores en el marco de las\n                Cátedras de la Diáspora Mexicana,"
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              se determina que cumple con los Criterios Específicos de Evaluación correspondientes al nivel\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.nivelEvaluacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            ". Asimismo, la persona investigadora cumple con los requisitos previstos en el artículo 19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19Dictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19Dictamen
                                              ) +
                                              ", del Reglamento del Sistema Nacional de Investigadoras\n              e Investigadores.\n            "
                                          ),
                                        ]),
                                      ]
                                    : _vm.esNoAprobado
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "\n              Con fundamento en los artículos 1, 2, 3, 5, Apartado B, fracción I, inciso b, 17, 18, 19, 20, 21 y 23 del Reglamento del\n              Sistema Nacional de Investigadoras e Investigadores; y 1, 2, 32, 35, 46 y 47 de los Lineamientos para el Funcionamiento del\n              Sistema Nacional de Investigadoras e Investigadores; así como de conformidad con los Criterios Específicos de Evaluación del\n              Sistema Nacional de Investigadoras e Investigadores la Comisión Revisora recomienda al Consejo General del Sistema Nacional\n              de Investigadoras e Investigadores\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(" no aprobar la solicitud"),
                                          ]),
                                          _vm._v(".\n            "),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "Lo anterior, con base en los siguientes motivos:"
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cuantitativa con lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 2. “Parámetros de Tecnología del SNII”"
                                            ),
                                          ]),
                                          _vm._v(
                                            " respecto al componente 1. Producción Tecnológica, ya que\n              presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteProduccionTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Desarrollo Tecnológico;\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponentePropiedadIntelectual
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Propiedad Intelectual; y,\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteTransferenciaTecno
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            " productos de Transferencia de Tecnología. Respecto al componente 2.\n              Fortalecimiento y Consolidación de la Comunidad, ya que presentó\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteFormacionComunidadDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades. Respecto al componente 3. Divulgación ya que presentó "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.totalComponenteDivulgacionDictamen
                                              )
                                            ),
                                          ]),
                                          _vm._v(
                                            "\n              actividades.\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En cuanto a la valoración cualitativa, de acuerdo a lo establecido en el\n              "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              "Anexo 4. “Rúbrica de Evaluación” "
                                            ),
                                          ]),
                                          _vm._v(
                                            " se consideraron las características para cada uno de los componentes de\n              la trayectoria de investigación, resultando "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.resultadoCualitativoDictamen
                                              ) + "."
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            "\n              En resumen, la Comisión considera que la trayectoria de investigación presentada no cumple con lo previsto en el artículo\n              19, fracción\n              " +
                                              _vm._s(
                                                _vm.fraccionArticulo19NivelAspiraDictamen
                                              ) +
                                              ". " +
                                              _vm._s(
                                                _vm.descripcionArticulo19NivelAspiraDictamen
                                              ) +
                                              ", del Reglamento del Sistema\n              Nacional de Investigadoras e Investigadores, así como los Criterios Específicos de Evaluación para ninguna categoría o nivel\n              en el SNII por:\n            "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c("b-form-textarea", {
                                              staticClass:
                                                "textarea-dictamen-negativo",
                                              attrs: {
                                                rows: "6",
                                                "max-rows": "12",
                                                state:
                                                  _vm.caracteresComentarioDictamenNegativo >=
                                                  _vm.caracteresMinimos,
                                                maxlength:
                                                  _vm.caracteresMaximos,
                                                placeholder: String(
                                                  _vm.$t(
                                                    "bandeja.comentariosPositvoNgetivo"
                                                  )
                                                ),
                                                disabled:
                                                  _vm.revision.estado !==
                                                  _vm.aceptada,
                                              },
                                              on: {
                                                input:
                                                  _vm.limitarComentariosDictamenNegativo,
                                                blur: _vm.tocarComentariosDictamenNegativo,
                                              },
                                              model: {
                                                value:
                                                  _vm.dictamenDiaspora
                                                    .comentarios,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dictamenDiaspora,
                                                    "comentarios",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dictamenDiaspora.comentarios",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end mt-1",
                                              },
                                              [
                                                _vm.comentarioDictamenNegativoRequerido
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " El comentario es obligatorio. "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm.caracteresComentarioDictamenNegativo <
                                                    _vm.caracteresMinimos
                                                  ? _c(
                                                      "small",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                  El mínimo requerido es de " +
                                                            _vm._s(
                                                              _vm.caracteresMinimos
                                                            ) +
                                                            " caracteres.\n                "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("small", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.caracteresComentarioDictamenNegativo
                                                          ) +
                                                          " de " +
                                                          _vm._s(
                                                            _vm.caracteresMaximos
                                                          ) +
                                                          " caracteres. "
                                                      ),
                                                    ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "line-break" }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c("div", { staticClass: "border-top mt-4 mb-4" }, [
                      _c("div", { staticClass: "mb-5 float-right" }),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      { staticClass: "mb-5 float-right" },
                      [
                        _vm.revision.estado === _vm.aceptada
                          ? _c(
                              "b-button",
                              {
                                attrs: {
                                  type: "submit",
                                  variant: "primary",
                                  size: "md",
                                  disabled:
                                    (_vm.hasAnyAuthority("ROLE_OPERADOR") &&
                                      _vm.authenticated) ||
                                    !_vm.authenticated ||
                                    !_vm.habilitarSave,
                                },
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("entity.action.save")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("font-awesome-icon", {
                                  staticClass: "mr-2",
                                  attrs: { icon: "save" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }